import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // user: null = checking, false = unauthenticated, object = authenticated
  const [user, setUser] = useState(null);
  const [account, setAccount] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    api
      .me()
      .then((data) => {
        setUser(data.user);
        setAccount(data.account);
      })
      .catch(() => {
        clearToken();
        setUser(false);
      });
  }, []);

  const applyAuth = (data) => {
    setToken(data.token);
    setUser(data.user);
    setAccount(data.account);
  };

  const login = async (email, password) => {
    const data = await api.login(email, password);
    applyAuth(data);
  };

  const signup = async (payload) => {
    const data = await api.signup(payload);
    applyAuth(data);
  };

  const updateProfile = async (name) => {
    const data = await api.updateProfile(name);
    setUser(data.user);
    setAccount(data.account);
  };

  const updateLanguage = async (language) => {
    const data = await api.updateLanguage(language);
    setUser(data.user);
    setAccount(data.account);
  };

  const logout = () => {
    clearToken();
    setUser(false);
    setAccount(null);
  };

  return (
    <AuthContext.Provider value={{ user, account, setAccount, login, signup, updateProfile, updateLanguage, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
